import React from 'react';
import { ArrowLeft, Shield } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Privacy = ({ onNavigate }) => {
  const { t } = useTranslation();
  const collectItems = t('privacy.sections.collect.items', { returnObjects: true });
  const useItems = t('privacy.sections.use.items', { returnObjects: true });
  const choiceItems = t('privacy.sections.choices.items', { returnObjects: true });

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-10 max-w-3xl w-full">
        <button
          onClick={() => onNavigate('/')}
          className="flex items-center gap-2 text-sm text-gray-500 hover:text-gray-700 mb-6"
        >
          <ArrowLeft className="w-4 h-4" />
          {t('privacy.backToDashboard')}
        </button>

        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 bg-purple-100 rounded-full flex items-center justify-center">
            <Shield className="w-5 h-5 text-purple-600" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">{t('privacy.title')}</h1>
            <p className="text-sm text-gray-600">{t('privacy.lastUpdated')}</p>
          </div>
        </div>

        <div className="space-y-5 text-sm sm:text-base text-gray-700 leading-relaxed">
          <p>{t('privacy.intro')}</p>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacy.sections.collect.title')}</h2>
            <ul className="list-disc pl-5 space-y-1">
              {collectItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacy.sections.use.title')}</h2>
            <ul className="list-disc pl-5 space-y-1">
              {useItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacy.sections.storage.title')}</h2>
            <p>{t('privacy.sections.storage.body')}</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacy.sections.sharing.title')}</h2>
            <p>{t('privacy.sections.sharing.body')}</p>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacy.sections.choices.title')}</h2>
            <ul className="list-disc pl-5 space-y-1">
              {choiceItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('privacy.sections.contact.title')}</h2>
            <p>
              {t('privacy.sections.contact.prompt')}{' '}
              <button onClick={() => onNavigate('/support')} className="font-medium text-purple-600 hover:text-purple-700">
                {t('privacy.sections.contact.link')}
              </button>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
